import { appendResponseHeader, splitCookiesString } from "h3";
import { navigateTo, useRequestEvent } from "#app";
function appendServerResponseHeaders(app, ctx, logger) {
  const event = useRequestEvent(app);
  const serverCookieName = "set-cookie";
  const cookieHeader = ctx.response.headers.get(serverCookieName);
  if (cookieHeader === null || event === void 0) {
    logger.debug(`[response] no cookies to pass to the client [${ctx.request}]`);
    return;
  }
  const cookies = splitCookiesString(cookieHeader);
  const cookieNameList = [];
  for (const cookie of cookies) {
    appendResponseHeader(event, serverCookieName, cookie);
    const cookieName = cookie.split("=")[0];
    cookieNameList.push(cookieName);
  }
  logger.debug(
    `[response] pass cookies from server to client response`,
    cookieNameList
  );
}
export default async function handleResponseHeaders(app, ctx, logger) {
  if (ctx.response === void 0) {
    logger.debug("[response] no response to process");
    return;
  }
  if (import.meta.server) {
    appendServerResponseHeaders(app, ctx, logger);
  }
  if (ctx.response.redirected) {
    await app.runWithContext(
      async () => await navigateTo(ctx.response.url)
    );
  }
}
